import { stylesheet } from 'typestyle';
import React from 'react';

const css = stylesheet({
  container: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
});

interface NewLayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: NewLayoutProps) => <div className={css.container}>{children}</div>;
